import React from 'react';
import { Table, InputNumber, Card, Tag, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Department, KPIDimension } from '../../../../services/kpiSettingsService';
import { MemberInfo } from '../TargetSettings'; // Will need to update import or types

interface DeptTargetTableProps {
    dept: Department;
    kpis: KPIDimension[];
    deptMembers: MemberInfo[];
    editingDeptTargets: Record<string, number>;
    editingMemberTargets: Record<string, number>;
    onDeptTargetChange: (deptId: number, dimId: number, val: number | null) => void;
    onMemberTargetChange: (memberId: number, dimId: number, val: number | null) => void;
    getMemberTargetSum: (deptId: number, dimId: number) => number;
}

export const DeptTargetTable: React.FC<DeptTargetTableProps> = ({
    dept, kpis, deptMembers, editingDeptTargets, editingMemberTargets,
    onDeptTargetChange, onMemberTargetChange, getMemberTargetSum
}) => {
    if (kpis.length === 0) {
        return (
            <Card size="small" title={dept.name} style={{ marginBottom: 20 }}>
                <div style={{ color: '#999', textAlign: 'center', padding: 20 }}>
                    该部门未配置 KPI，请先在 "部门KPI设置" 中配置。
                </div>
            </Card>
        );
    }

    const columns = [
        {
            title: 'KPI指标', dataIndex: 'name', key: 'name', width: 150, fixed: 'left' as const,
        },
        {
            title: '部门总目标', width: 150,
            render: (_: any, r: KPIDimension) => (
                <InputNumber
                    style={{ width: '100%' }}
                    value={editingDeptTargets[`${dept.id}-${r.id}`]}
                    onChange={v => onDeptTargetChange(dept.id, r.id, v)}
                    placeholder="目标值"
                />
            )
        },
        {
            title: '人员汇总', width: 120,
            render: (_: any, r: KPIDimension) => {
                const sum = getMemberTargetSum(dept.id, r.id);
                const target = editingDeptTargets[`${dept.id}-${r.id}`] || 0;
                const diff = sum - target;
                const isMatch = Math.abs(diff) < 0.01;
                return (
                    <Tooltip title={isMatch ? '汇总一致' : `差异: ${diff > 0 ? '+' : ''}${diff.toFixed(2)}`}>
                        <Tag color={isMatch ? 'success' : 'warning'}>{sum}</Tag>
                    </Tooltip>
                );
            }
        },
        ...deptMembers.map(m => ({
            title: m.full_name || m.username, width: 120,
            render: (_: any, r: KPIDimension) => (
                <InputNumber
                    style={{ width: '90%' }} size="small"
                    value={editingMemberTargets[`${m.id}-${r.id}`]}
                    onChange={v => onMemberTargetChange(m.id, r.id, v)}
                />
            )
        }))
    ];

    return (
        <Card size="small" title={dept.name} style={{ marginBottom: 20 }} key={dept.id}>
            {deptMembers.length === 0 && (
                <div style={{ marginBottom: 10, color: '#faad14' }}>
                    <InfoCircleOutlined /> 该部门暂无成员
                </div>
            )}
            <Table
                dataSource={kpis} columns={columns} rowKey="id" pagination={false}
                bordered size="small" scroll={{ x: 'max-content' }}
            />
        </Card>
    );
};
